<template>
    <div>
        <b-btn @click="showPopUp" :disabled="loadingBtn" variant="danger">
            <span>Set New Item Availability Control</span>
            <font-awesome-icon icon="plus" class="align-middle mx-1"/>
        </b-btn>
        <c-modal
            v-model="modal"
             cancel-label="Cancel"
             centered
             title="Add Item Availability Control"
             :tag="false"
             confirm-label="Add Control"
             :progressing="loadingBtn"
             size="lg"
             @submit="addItem"
        >
            <template>
                <b-container class="p-0">
                    <b-row>
                        <b-col cols="12">
                            <b-form-group class="text-center" label="">
                                <b-form-radio-group @change="changeItemType" class="" size="lg" id="radio-group-2" v-model="ItemType" name="radio-sub-component">
                                    <b-form-radio class="mx-5" size="lg" value="Food">Food</b-form-radio>
                                    <b-form-radio class="mx-5" size="lg" value="Drink">Drink</b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <div class="overflow-auto">
                                <b-button-group class="groupsButtons" size="sm">
                                    <b-button
                                            style="font-size: 0.9rem"
                                            v-for="item in MenuTypeAl"
                                            class="py-4 px-3"
                                            @click="GetRestaurantItems(item, item.MenuTypeID, ItemType)"
                                            :class="item.selected ? 'activeBtn' : 'deactiveBtn'"
                                            :disabled="item.disabled"
                                    >
                                        {{item.MenuType}}
                                    </b-button>
                                </b-button-group>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <div class="my-3 multiselect-availability">
                                <Multiselect
                                        class="miniMulti"
                                        v-model="ItemCategory"
                                        :options="RestaurantItems"
                                        v-validate="'required'"
                                        name="item"
                                        placeholder="انتخاب کنید"
                                />
                            </div>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-input-group prepend="Quantity Limit" class="my-3">
                                <b-input type="number" @keypress="preventTypeString" v-model="QuantityLimit" v-validate="'required|min_value:1'" name="Quantity Limit"/>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" md="6" class="align-self-center">
                            <div style="background: #ffeaf1" class="p-2">
                                <div>
                                    <b-form-checkbox
                                            id="checkbox-1"
                                            v-model="reset"
                                            name="checkbox-1"
                                            :value="true"
                                            :unchecked-value="false"
                                            class="mb-2"
                                    >
                                    End of Day Quantity Limit Reset
                                    </b-form-checkbox>
                                    
                                </div>
                                <span v-if="reset" >Reset item availabilty at End of Day to:</span>

                                <div class="mt-3 ml-4" v-if="reset">

                                    <b-form-group name="ResetAction" v-slot="{ ariaDescribedby }">
                                        <b-form-radio class="mb-3" v-model="ResetAction" :aria-describedby="ariaDescribedby" name="ResetAction" value="r">Quantity Limit</b-form-radio>
                                        <b-form-radio v-model="ResetAction" :aria-describedby="ariaDescribedby" name="ResetAction" value="d">Unlimited (Suspend this control permanently)</b-form-radio>
                                    </b-form-group>
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <b-alert :show="errors.any()" variant="danger" class="px-4 my-2">
                                <ul class="m-0 px-1">
                                    <li v-for="err in errors.all()" :key="err">{{err}}</li>
                                </ul>
                            </b-alert>
                        </b-col>
                    </b-row>
                </b-container>
            </template>
        </c-modal>
    </div>
</template>

<script>
    import moment from "moment";
    import Multiselect from '../../shared/multiselect'
    import CModal from "../../shared/Cmodal";

    export default {
        name: "addAvailable",
        components: {
            CModal,
            Multiselect
        },
        data () {
            return {
                loadingBtn: false,
                modal: false,
                confirmationDeleteModal: false,
                ItemType: 'Food',
                RestaurantItems: [],
                QuantityLimit: null,
                DrinkID: null,
                FoodId: null,
                ItemCategory: null,
                SelectedMenuType: null,
                status: false,
                reset: false,
                ResetAction: 'r',
                MenuTypeAl: []
            }
        },
        mounted () {
        },
        methods: {
            preventTypeString (evt) {
                if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57){
                    evt.preventDefault();
                }
            },
            showPopUp () {
                this.loadingBtn = true
                this.GetRestaurantMenuTypes(this.ItemType).then(() => {
                    this.loadingBtn = false
                    this.modal = true
                })
            },
            changeItemType (value) {
                //filter menu types by two value - drink or food

                this.GetRestaurantMenuTypes(value)
            },
            GetRestaurantMenuTypes (ItemType) {
                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    ItemType
                }
                return this.$api.getRestaurant.GetRestaurantMenuTypes(model).then(res => {
                    if (res.success) {
                        this.RestaurantItems = []
                        this.ItemCategory = null
                        this.PriceType = null
                        this.MenuTypeAl = res.results.RestaurantMenuTypeAll.filter(item => item.CanMenuTypeBeShown)
                        this.MenuTypeAl.forEach(item => {
                            if (item.RestaurantMenuTypeHoursToday.length) {
                                let arr = item.RestaurantMenuTypeHoursToday[0]
                                let start = arr.StartTime.includes('PM') ? moment(arr.StartTime.substr(0,5), 'HH:mm').add(12, 'hours'): moment(arr.StartTime.substr(0,5), 'HH:mm')
                                let end = arr.EndTime.includes('PM') ? moment(arr.EndTime.substr(0,5), 'HH:mm').add(12, 'hours'): moment(arr.EndTime.substr(0,5), 'HH:mm')
                                let hourStartStr = moment(start).format('HH:mm')
                                let hourEndStr = moment(end).format('HH:mm')
                                let currentDate = moment().format('YYYY/M/D')
                                item.StartTime = currentDate + ' ' + hourStartStr
                                item.EndTime = currentDate + ' ' + hourEndStr
                            } else {
                                item.StartTime = ''
                                item.EndTime = ''
                            }
                            this.$set(item, 'selected', false)
                            if (this.orderType === 'Pickup') {
                                if (this.specialStatus && this.specialMenuType !== '') {
                                    this.$set(item, 'disabled', true)
                                    if (item.MenuTypeID === this.specialMenuType) {
                                        this.$set(item, 'selected', true)
                                        this.$set(item, 'disabled', false)
                                        this.GetRestaurantItems(item, item.MenuTypeID, 'Food')
                                    }
                                } else {
                                    if (item.IsSpecial) {
                                        this.$set(item, 'disabled', true)
                                    } else {
                                        if (item.EndTime !== '' && item.StartTime !== '') {
                                            item.stringStartDate = moment(item.StartDate).format('YYYY/M/D HH:mm')
                                            item.stringEndDate = moment(item.EndDate).format('YYYY/M/D HH:mm')
                                            if (moment(this.setHour).isBetween(item.StartTime, item.EndTime)) {
                                                this.$set(item, 'disabled', false)
                                            } else {
                                                this.$set(item, 'disabled', true)
                                            }
                                        }
                                        else {
                                            this.$set(item, 'disabled', false)
                                        }
                                    }
                                }
                            }
                            else if (this.orderType === 'DineIn') {
                                this.$set(item, 'disabled', false)
                            } else if (this.orderType === 'Delivery') {
                                if (item.CanBeDelivered) {
                                    if (item.EndTime !== '' && item.StartTime !== '') {
                                        item.stringStartDate = moment(item.StartDate).format('YYYY/M/D HH:mm')
                                        item.stringEndDate = moment(item.EndDate).format('YYYY/M/D HH:mm')
                                        if (moment(this.setHour).isBetween(item.StartTime, item.EndTime)) {
                                            this.$set(item, 'disabled', false)
                                        } else {
                                            this.$set(item, 'disabled', true)
                                        }
                                    } else {
                                        this.$set(item, 'disabled', false)
                                    }
                                } else {
                                    this.$set(item, 'disabled', true)
                                }
                            }
                        })
                        if (this.MenuTypeAl.length === 1) {
                            this.MenuTypeAl.forEach(item => {
                                this.$set(item, 'selected', false)
                                item.selected = true
                                this.GetRestaurantItems(item, item.MenuTypeID, ItemType)

                            })
                        }
                    } else {
                        this.$showError(res.message)
                    }
                })
            },
            GetRestaurantItems (item, MenuTypeID, ItemType) {
                //get restaurant items by selected menutype and item type
                this.SelectedMenuType = item
                this.MenuTypeAl.forEach(i => {
                    i.selected = false
                })
                item.selected = true
                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    ItemType,
                    MenuTypeID
                }
                this.$api.getRestaurant.GetRestaurantItems(model).then(res => {
                    if (res.success) {
                        this.ItemCategory = null
                        this.PriceType = null
                        let result =  res.results.RestaurantItems
                        result.forEach(item => {
                            item.value = item.ItemID
                            item.availablePrices = [
                                {text: 'Price', value: item.Price},
                                {text: 'Price1', value: item.Price1},
                                {text: 'Price2', value: item.Price2},
                                {text: 'Price3', value: item.Price3},
                                {text: 'Price4', value: item.Price4},
                            ]
                            if (item.availablePrices.filter(i => i.value > 0).length > 1) {
                                item.priceSymbol = ' + '
                            } else {
                                item.priceSymbol = ''
                            }
                            if (item.HasModifier) {
                                item.priceSymbol = ' + '
                            }
                            if (item.Price !== -999999) {
                                item.name = item.ItemCategory + ' - ' + item.ItemName + ' - ' + '$' + item.Price + item.priceSymbol + (item.IsAvailable ? '' : ' (Not available till further notice)')
                            } else {
                                item.name = item.ItemCategory + ' - ' + item.ItemName + ' ' + item.priceSymbol + (item.IsAvailable ? '' : ' (Not available till further notice)')
                            }

                        })
                        this.RestaurantItems = result

                    } else {
                        this.$showError(res.message)
                    }
                })
            },
            addItem () {
                this.$validator.validateAll().then(res => {
                    if (res) {
                        const object = {
                            // UserID: localStorage.getItem('userID'),
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            ItemID: this.ItemCategory.ItemID,
                            ItemType: this.ItemType,
                            Breakdown: 0,
                            Total: this.QuantityLimit,
                            Total_Remain: this.QuantityLimit,
                            Pickup: '',
                            Delivery: '',
                            Dinein: '',
                            ResetAction: this.reset ? this.ResetAction : ''
                        }
                        this.loadingBtn = true
                        this.$api.getRestaurant.UpdateItemAvailability(object).then(res => {
                            this.loadingBtn = false
                            if (res.success) {
                                this.modal = false
                                this.resetData()
                                this.$emit('refreshGetAll', this.$store.state.selectedRestaurantId)
                            } else {
                                this.$showError(res.message)
                            }
                        }).catch(() => {
                            this.loadingBtn = false
                        })
                    }
                })
            },
            resetData () {
                this.ResetAction = 'r'
                this.reset = false
                this.ItemCategory = null
                this.QuantityLimit = null
                this.GetRestaurantMenuTypes(this.ItemType)
            }
        }
    }
</script>
<style>
    .miniMulti{
        font-size: 1.2em;
    }
</style>
<style scoped lang="scss">
    .activeBtn {
        background: #f5c31d !important;
        border-color: #464b50 !important;
    }
    .deactiveBtn {
        background: #fff !important;
        border-color: #464b50 !important;
        color: #464b50 !important;
    }
    .groupsButtons{
        .disabled{
            background: #fff !important;
            border-color: #c4c9ce !important;
            color: #c4c9ce !important;
        }
    }
    select{
        option{
            span#itemName{
                font-weight: bold !important;
                color: red !important;
            }
        }
    }
</style>
